var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "custom-page-root" },
    [
      _vm.env.isApp
        ? [
            _c(
              "div",
              {
                staticClass: "custom-nav-block",
                style: `padding-top:${_vm.barHeight}px`,
              },
              [
                _c("van-nav-bar", {
                  staticClass: "van-bar",
                  attrs: { title: "", "left-arrow": "" },
                  on: { "click-left": _vm.closeWeb },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function () {
                          return [
                            _c("img", {
                              staticClass: "left-nav",
                              attrs: {
                                src: require("@/assets/packageAssets/common/arrow02.png"),
                                alt: "",
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    782671113
                  ),
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "custom-page-con",
                style: `margin-top:-${_vm.barHeight + 46}px`,
              },
              [
                _vm.imgUrl
                  ? _c("img", {
                      staticClass: "content-img",
                      attrs: { src: _vm._f("imgPath")(_vm.imgUrl) },
                    })
                  : _c("div", { staticClass: "page-404" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/packageAssets/common/null_bg.png"),
                        },
                      }),
                    ]),
              ]
            ),
          ]
        : [
            _c("div", { staticClass: "custom-page-con" }, [
              _vm.imgUrl
                ? _c("img", {
                    staticClass: "content-img",
                    attrs: { src: _vm._f("imgPath")(_vm.imgUrl) },
                  })
                : _vm._e(),
              !_vm.imgUrl && !_vm.isLoading
                ? _c("div", { staticClass: "page-404" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/packageAssets/common/null_bg.png"),
                      },
                    }),
                  ])
                : _vm._e(),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }